@if (!!cmsResponse && !!imageUrl) {
  <a href="unsafe:javascript:void(0)" rel="{{redirectionLink}}" type="{{type}}"
    class="app-navigation-links" [ngClass]="{'disable-Link' : !redirectionLink}" (click)="gtmSelectPromotion()">
    <section>
      <img src="{{ imageUrl }}" alt="img" class="imgWidth" />
      @if (cmsResponse?.linkText && cmsResponse?.urlLink) {
        <a href="{{cmsResponse?.urlLink}}" class="redirectionUrl" target="_blank"
        (click)="gtmSelectPromotion()">{{cmsResponse?.linkText}}</a>
      }
    </section>
  </a>
}